import {excelApi} from 'common/src/modules/excel/excel.api';
import {CopilotFileContentType} from 'common/src/modules/shared/copilot/copilot.enums';
import {ToolUtils} from 'common/src/modules/shared/copilot/copilot.types';
import {StartAndEndDatePairInfo} from '../sanitizeValuesTool.types';

async function getStartAndEndDatePairs({
  toolUtils,
  fileId,
  worksheetIndex,
  firstDataRowIndex,
  startDateColumnIndex,
  endDateColumnIndex,
}: {
  toolUtils: ToolUtils;
  fileId: string;
  worksheetIndex: number;
  firstDataRowIndex: number;
  startDateColumnIndex: number;
  endDateColumnIndex: number;
}): Promise<StartAndEndDatePairInfo[]> {
  const fileInfo = toolUtils.getFileById(fileId);

  if (!fileInfo) {
    throw Error(`File (ID: ${fileId}) not found`);
  }

  if (fileInfo.content?.type !== CopilotFileContentType.Excel) {
    throw Error(`File (ID: ${fileId}) is not an excel file`);
  }

  const [worksheet] = await excelApi.readExcelFile({
    fileKey: fileInfo.fileKey,
    worksheetIndex,
  });

  const dataRows = worksheet.rows.slice(firstDataRowIndex);

  const startDateAndEndDatePairs: StartAndEndDatePairInfo[] = dataRows.map((row, index) => ({
    rowIndex: firstDataRowIndex + index,
    startDate: row[startDateColumnIndex] ?? '',
    endDate: row[endDateColumnIndex] ?? '',
  }));

  // remove any rows where both start date and end date are empty, there's no need to sanitize them
  const filteredStartDateAndEndDatePairs = startDateAndEndDatePairs.filter(
    (pair) => pair.startDate !== '' && pair.endDate !== '',
  );

  return filteredStartDateAndEndDatePairs;
}

export default getStartAndEndDatePairs;
